__turbopack_context__.v({
  "menuLink": "awMY7W_menuLink",
  "menuLinkActive": "awMY7W_menuLinkActive",
});
